module.exports = __webpack_public_path__ + "files/07b8e222be3595401e02fac1c205f681.png";